import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { ApiService } from '../../../../services/api.service';
import { ConfirmationService } from 'primeng/api';
import { DatePipe } from '@angular/common';
import { ConfirmPopup } from 'primeng/confirmpopup';
import { Table } from 'primeng/table';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Spettacolo, TimelineSpettacolo } from '../../../../shared/interface';

@Component({
  selector: 'app-timeline-spettacolo-backoffice',
  templateUrl: './timeline-spettacolo-backoffice.component.html',
  styleUrl: './timeline-spettacolo-backoffice.component.css'
})
export class TimelineSpettacoloBackofficeComponent {

  constructor(private apiService: ApiService, private confirmationService: ConfirmationService, private datePipe: DatePipe) {}
    
  @ViewChild(ConfirmPopup) delete!: ConfirmPopup;

  @Input() spettacolo?: Spettacolo;
  @Input() timelines: TimelineSpettacolo[] = [];
  @Output() data = new EventEmitter<TimelineSpettacolo[]>();
  
  timeline?: TimelineSpettacolo;  

  immagine: string = '';
  pdf: File | null = null;
  show_pdf: boolean = true;

  add: boolean = false;
  edit: boolean = false;

  formTimeline!: FormGroup;  

  ngOnInit(): void {

    this.formTimeline = new FormGroup({
      data: new FormControl(null, Validators.required),
      titolo: new FormControl(null, Validators.required),
      descrizione: new FormControl(null),
      immagine: new FormControl(null),
      pdf: new FormControl(null)
    })

    this.timelines.filter(timeline => timeline.pdf).map(timeline => this.show_pdf = false)

  }

  onGlobalFilter(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  onOpenAdd() {
    this.add = true;
    this.formTimeline.reset();
    this.formTimeline.markAsPristine();
    this.formTimeline.markAsUntouched();
  }

  onAdd() {

    const formData = new FormData();
    formData.append('file', this.pdf || '');
    formData.append('immagine', this.immagine || '');
    formData.append('data', this.datePipe.transform(this.formTimeline.get('data')?.value || '', 'yyyy-MM-dd') || '');
    formData.append('titolo', this.formTimeline.get('titolo')?.value || '');
    formData.append('descrizione', this.formTimeline.get('descrizione')?.value || '');
    formData.append('posizione', (this.timelines.length + 1).toString());

    this.apiService.addTimelineSpettacolo(formData, this.spettacolo!.id).subscribe({
      next: (data) => { },
      error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
      complete: () => {

        this.apiService.getTimelineSpettacolo(this.spettacolo!.id).subscribe({
          next: (data) => this.timelines = [...data],
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.onCloseModal();
          }
        })
      }
    })

  }

  onOpenEdit(timeline: TimelineSpettacolo) {

    this.timeline = timeline;

    this.formTimeline.setValue({
      data: new Date(timeline.data),
      titolo: timeline.titolo,
      descrizione: timeline.descrizione,
      immagine: timeline.immagine,
      pdf: timeline.pdf || ''
    })

    this.edit = true;
  }

  onEdit() {

    this.timelines.filter(timeline => timeline === this.timeline).map(timeline => {
      timeline.data = this.formTimeline.get('data')?.value || '';
      timeline.titolo = this.formTimeline.get('titolo')?.value || '';
      timeline.descrizione = this.formTimeline.get('descrizione')?.value || '';
    });

    this.onCloseModal();

  }

  onImmagineUpload(file: File | File[] | null) {
    if (!file || Array.isArray(file)) {
      this.immagine = '';
      this.formTimeline.patchValue({ immagine: '' });
      return;
    }

    const reader = new FileReader();
    reader.onload = () => {
      this.immagine = reader.result as string;
    }
    reader.readAsDataURL(file);

    this.formTimeline.patchValue({ immagine: file.name });
  };

  onPDFUpload(file: File | File[] | null) {
    if (!file || Array.isArray(file)) {
      this.pdf = null;
      this.formTimeline.patchValue({ pdf: '' });
      return;
    }
    this.pdf = file;
    this.formTimeline.patchValue({ pdf: file.name });
  };

  onOpenDelete(event: Event, timeline: TimelineSpettacolo, index: number) {
    this.confirmationService.confirm({
      target: event.target as EventTarget,
      message: "Sei sicuro di voler il punto nella timeline dallo spettacolo?",
      reject: () => this.confirmationService.close(),
      accept: () => {
        this.apiService.deleteTimelineSpettacolo(timeline.id).subscribe({
          error: (err) => this.apiService.message('error', 'Errore', err.error.message.message),
          complete: () => {
            this.confirmationService.close()
            this.timelines.splice(index, 1)
            this.apiService.message("success", "Eliminazione", "La timeline è stata eliminata con successo")
          }
        })
      }
    });
  }

  onDelete() {
    this.delete.accept();
  }

  onAnnullaDelete() {
    this.delete.reject();
  }

  onCloseModal() {    
    this.add = false;
    this.edit = false;
  }

}
